import { createStateHook } from 'react-sweet-state';

import { RovodalStore } from './store-internal';
import type { RovodalStoreState } from './types';

/** Read the whole `byKey` map. Prefer the keyed `useRovodal` hook where possible. */
export const useRovodalStoreState: () => RovodalStoreState = createStateHook(RovodalStore);
